import { SkeletonBox } from '@/shared/ui';

const StationInfoSkeleton = () => {
	return (
		<div className="flex items-start justify-between self-stretch pb-5">
			<div className="flex flex-col gap-2.5">
				<SkeletonBox className="h-6 w-32" />
				<SkeletonBox className="h-5 w-48" />
				<SkeletonBox className="h-5 w-24" />
			</div>
			<SkeletonBox className="h-6 w-6 rounded-full" />
		</div>
	);
};

export default StationInfoSkeleton;
